import React from 'react';
import { connect } from 'react-redux';
import PianoChart from 'components/common/charts/pianochart';
import config from 'config';
import ModeSelector from 'components/common/dropdowncomponents/modeselector';
import DaySelector from 'components/common/dropdowncomponents/dayselector';
import LineChart from 'components/common/charts/linechart';
import Dropdown from 'components/common/dropdowncomponents/dropdown';
//import Modal from "components/common/modal";
export class PianoChartContainer extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            mode: 'Average',
            day: 'Mondays',
            pianoChart: this.getDataForPianoChart(this.props, "Average"),
            lineChart: this.getLineChartData(this.props, "Mondays")
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            pianoChart: this.getDataForPianoChart(nextProps, this.state.mode),
            lineChart: this.getLineChartData(nextProps, this.state.day)
        }, () => {
            if (!nextProps.showPeak) {
                this.chooseMode("Average")
            }
        })
    }

    chooseMode(mode) {
        this.setState({ mode: mode }, () => {
            this.setState({
                pianoChart: this.getDataForPianoChart(this.props, this.state.mode)
            });
        });
    }

    chooseDay(day) {
        this.setState({ day: day }, () => {
            this.setState({
                lineChart: this.getLineChartData(this.props, this.state.day)
            });
        });
    }

    // Piano chart functions

    getDataForPianoChart(props, mode) {
        let data = {
            labelsY: [],
            labelsX: [],
            values: []
        }
        this.getStatsDayInWeek(props, data, mode);
        this.getStatsAllDay(data, mode);
        if (props.stats.constraint) {
            for (var i = parseInt(props.stats.constraint.starthour); i <= parseInt(props.stats.constraint.endhour); i++) {
                data.labelsX.push(i);
            }
        }
        for (let i in data.values) {
            for (let j in data.values[i]) {
                data.values[i][j] = Math.round(data.values[i][j]);
            }
        }
        return data;
    }

    getStatsDayInWeek(props, data, mode) {
        let count = 0;
        for (let name in props.stats.values) {
            data.values[count] = [];
            for (let hour in props.stats.values[parseInt(name)]) {
                if (mode == 'Average') {
                    data.values[count].push(props.stats.values[name][hour].avg * 100);
                }
                else {
                    data.values[count].push(props.stats.values[name][hour].pk * 100);
                }
            }
            count++;
            data.labelsY.push(config.day[parseInt(name)]);
        }
    }

    getStatsAllDay(data, mode) {
        var res = [];
        if (data.values.length == 0) return;
        for (var hour = 0; hour < data.values[0].length; hour++) { // all hours (column)
            let avg = 0;
            let count = 0;
            let pk = 0;
            for (var weekday = 0; weekday < data.values.length; weekday++) { // all weekdays (rows, except last rows which is for all days)
                if (data.values[weekday][hour] >= 0) {
                    avg += data.values[weekday][hour];
                    pk = Math.max(pk, data.values[weekday][hour]);
                    count++;
                }
            }
            if (mode == "Average") {
                res.push((count != 0) ? avg / count : -100);
            } else {
                res.push(pk);
            }
        }
        data.values.push(res);
        data.labelsY.push("All days");
    }

    // Line chart functions

    getLineChartData(props, day) {
        let data = {
            labels: [],
            peaks: [],
            avgs: []
        }
        if (props.stats.constraint && props.stats.values) {
            let values = props.stats.values;
            let starthour = props.stats.constraint.starthour;
            let endhour = props.stats.constraint.endhour;

            for (let hour = starthour; hour <= endhour; hour++) {
                var sumAvg = 0, cntAvg = 0, peak = 0;
                for (let weekday in values) {
                    if (day == "All days" || config.day.indexOf(day) == parseInt(weekday)) {
                        if (values[weekday][hour].avg >= 0 && values[weekday][hour].pk >= 0) {
                            sumAvg += values[weekday][hour].avg;
                            cntAvg++;
                            peak = Math.max(peak, values[weekday][hour].pk)
                        }
                    }
                }
                var avg = sumAvg / cntAvg;
                data.labels.push(hour);
                if (avg >= 0 && peak >= 0) {
                    data.avgs.push(Math.round(avg * 100));
                    data.peaks.push(Math.round(peak * 100));
                } else {
                    data.peaks.push(null);
                    data.avgs.push(null);
                }
            }
        }
        if (!props.showPeak) {
            data.peaks = [];
        }
        return data;
    }

    render() {
        return (
            <React.Fragment>
                <div className="stats-card">
                    <div className="box--shadow bg--white card__graph clearfix" style={{ minHeight: '650px' }} ref={(e) => { document.charts.dailyOccupancy1 = e }}>
                        <div className="clearfix graph__header">
                            <div className="graph__header__title col-sm-offset-3 col-sm-6 col-xs-12  clearfix">
                                <h2 >Daily {this.props.tag}: All Weekdays</h2>
                            </div>
                            <div className="graph__header__options clearfix">
                                {/*  <Modal
                                disableCloseButton={true}
                                ref={(elem) => { this.openPianoInfoModal = elem }}
                                clickButton={() => { this.openPianoInfoModal.close(); }}
                                header="Info Modal"
                                buttonText="Got it"
                                buttonClass="btn-success"
                                entry={
                                    <div className="pull-right header__options__child">
                                        <div onClick={() => { this.openPianoInfoModal.open() }}>
                                            <img className="card-info cursor--pointer" src="src/assets/icons/info.svg" alt="info-icon" />
                                        </div>
                                    </div>}
                            >
                                <p>Daily Piano chart : All Weekdays Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum</p>
                            </Modal>
                         */}
                                <div className="header__options__child pull-right">
                                    {
                                        (this.props.showPeak) ?
                                            <ModeSelector mode={this.state.mode} chooseMode={this.chooseMode.bind(this)} />
                                            :
                                            <Dropdown className=" no--cursor--pointer" header={this.state.mode} noArrow={true} toggleable={false} />
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="graph__body">
                            <div style={{ marginLeft: "-10px" }}>
                                <PianoChart id="dailyOccupancy1" data={this.state.pianoChart} />
                            </div>
                            <div style={{ marginLeft: '90px' }}>
                                <img src="src/assets/icons/degree.png" />
                                <h5 style={{ marginLeft: '0px', marginTop: '5px' }}>0 - 20% &emsp; &emsp; &emsp;20 - 40% &emsp; &emsp;&emsp;40 - 60%&emsp; &emsp; &emsp;60  -80%&emsp; &emsp; &emsp;80 - 100% </h5>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="stats-card">
                    <div className="box--shadow bg--white card__graph" ref={(e) => { document.charts.dailyOccupancy2 = e }}>
                        <div className="clearfix graph__header">
                            <div className="graph__header__title col-sm-offset-3 col-sm-6 clearfix">
                                <h2 >Daily {this.props.tag}</h2>
                            </div>
                            <div className="graph__header__options clearfix">
                                {/*
                            <Modal
                                disableCloseButton={true}
                                ref={(elem) => { this.openLineChartInfoModal = elem }}
                                clickButton={() => { this.openLineChartInfoModal.close(); }}
                                header="Info Modal"
                                buttonText="Got it"
                                buttonClass="btn-success"
                                entry={
                                    <div className="pull-right header__options__child">
                                        <div onClick={() => { this.openLineChartInfoModal.open() }}>
                                            <img className="card-info cursor--pointer" src="src/assets/icons/info.svg" alt="info-icon" />
                                        </div>
                                    </div>
                                }
                            >
                                <p>Daily Linechart Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum</p>
                            </Modal>
                          */}
                                <div className="header__options__child pull-right">
                                    <DaySelector day={this.state.day} chooseDay={this.chooseDay.bind(this)} items={this.state.pianoChart.labelsY} />
                                </div>
                            </div>
                        </div>
                        <div className="graph__body">
                            <LineChart id="dailyOccupancy2" stats={this.state.lineChart} />
                        </div>
                    </div>
                </div>
            </React.Fragment >
        );
    }
}

function mapStateToProps(state) {
    return {
        stats: state.statsReducer.daily
    };
}

export default connect(mapStateToProps, null)(PianoChartContainer);


// WEBPACK FOOTER //
// ./src/components/pages/stats/dailyoccupancy/pianochartcontainer.jsx